module.exports = __webpack_public_path__ + "img/howtohl.b7b8219c.jpg";